
export default class Tabs{
    constructor(node){
        this.tabs = node
        this.tabButtons = this.tabs.querySelectorAll('.tab-button')
        this.tabContentsContainer = this.tabs.querySelector('.tab-contents')
        this.tabContents = this.tabs.querySelectorAll('.tab-content')
        this.listeners = []
        this.resizeHandler = this.adjustTabContentsHeight.bind(this)
        this.mutationObservers = new Map()

        this.initTabs()
        this.initializeTabVisibility()
        this.adjustTabContentsHeight()
    }

    initTabs() {
		// console.debug('  -> Tabs init')

		this.tabButtons.forEach((tabButton) => {

            const clickHandler = (event) => {
                const targetSelector = event.currentTarget.getAttribute('tab-target')
                const targetContent = this.tabs.querySelector('#'+targetSelector)
        
                // Remove 'active' class from all buttons
                this.tabButtons.forEach((btn) => btn.classList.remove('active'))
                event.currentTarget.classList.add('active')
        
                // Remove 'show' class from all contents except target
                this.tabs.querySelectorAll('.tab-content').forEach((content) => {
                    if( content !== targetContent ){
                        content.classList.remove('show')
                        setTimeout(() => {
                            content.style.display = 'none'
                        }, 500)
                    }
                })
        
                // Forcing reflow to avoid glitches
                void targetContent.offsetWidth;
        
                // Adding 'show' class to target content
                if (targetContent) {
                    targetContent.style.display = ''
                    setTimeout(() => {
                        targetContent.classList.add('show')
                    }, 250)
                    this.adjustTabContentsHeight()
                }
            }

            // Adding event listener to array
            tabButton.addEventListener('click', clickHandler)
            this.listeners.push({ button: tabButton, handler: clickHandler })
        })

        window.addEventListener('resize', this.resizeHandler)

        // Adding observer to each Tab elenemt
        this.tabContents.forEach(tabContent => {
            this.observeTabContent(tabContent)
        })
    }

    initializeTabVisibility() {
        let initialActiveTabContent = this.tabContentsContainer.querySelector('.tab-content.show')

        // If there are no active tab setting first one as active
        if( !initialActiveTabContent && this.tabContents.length > 0 ){
            initialActiveTabContent = this.tabContents[0]

            const initialTabButton = this.tabButtons[0]
            if( initialTabButton ){
                initialTabButton.classList.add('active')
            }
        }

        this.tabContents.forEach(content => {
            if( content === initialActiveTabContent ){
                // Initial active tab
                content.classList.add('show')
            } else {
                // All the other tabs
                content.classList.remove('show')
                content.style.display = 'none'
            }
        })
    }

    observeTabContent(targetContent) {
        // Check if the current element already have an observer and disconnect it before creating a new one
        if (this.mutationObservers.has(targetContent)) {
            this.mutationObservers.get(targetContent).disconnect()
        }

        const observer = new MutationObserver((mutations) => {
            // Calculating height only for the active tab
            if( targetContent.classList.contains('show') ){
                this.adjustTabContentsHeight()
            }
        })

        const config = {
            attributes: true,       // Observe attribute changes (e.g., class changes)
            childList: true,        // Observe additions/removals of child nodes
            subtree: true,          // Observe changes in the entire subtree of the element
            characterData: true     // Observe changes in the text content of nodes
        }

        observer.observe(targetContent, config)
        this.mutationObservers.set(targetContent, observer) // Salva l'observer nella Map
    }

    adjustTabContentsHeight() {
        const activeTabContent = this.tabContentsContainer.querySelector('.tab-content.show')
        if( activeTabContent ){
            // Obtaining effective height for active content, including padding and borders
            const height = activeTabContent.offsetHeight
            if( height > 0 ) this.tabContentsContainer.style.height = `${height}px`
        }
    }

    destroy() {
        // console.debug('  -> Destroying Tabs');
        this.listeners.forEach(({ button, handler }) => {
            button.removeEventListener('click', handler)
        })
        this.listeners = []
        this.tabContentsContainer.style.height = ''
        window.removeEventListener('resize', this.resizeHandler)

        this.mutationObservers.forEach(observer => observer.disconnect())
        this.mutationObservers.clear()
    }

    static reset() {
        // console.debug('  -> Resetting Tabs components')
        if (Tabs.items) {
            Tabs.items.forEach(item => item.destroy())
        }
        Tabs.init()
    }

    static init() {
        // console.debug('== Initializing Tabs components ==')
        Tabs.items = Array.from(document.querySelectorAll('.tabs-container')).map(
            (tabs) => new Tabs(tabs)
        )
    }
}